// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"73573ac2","977":"7de16a02"}[chunkId] + ".chunk.js";
};